import{IconAlert as e}from"../src/elements/IconAlert.js";customElements.define("sp-icon-alert",e);
//# sourceMappingURL=sp-icon-alert.js.map
